<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showError" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          Por favor, selecione pelo menos uma empresa.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showError = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterDownload" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center"> Em Manutenção </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilterDownload = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-divider></v-divider>
    <br /><br />

    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-link-variant"
            title="Controle de Vínculos"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form">
              <v-row style="margin-top: 1rem">
                <v-col cols="12" sm="12">
                  <span>Colaborador</span>
                  <v-select
                    :items="vendedoresFormatados"
                    item-text="displayName"
                    item-value="id"
                    v-model="controle.codigoPessoa"
                    filled
                    label="Selecione um Colaborador"
                    dense
                    solo-inverted
                    hide-details
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6">
                  <span>Local</span>
                  <v-select
                    :items="locais"
                    filled
                    v-model="controle.tipo"
                    label="Selecione o Local"
                    dense
                    solo-inverted
                    hide-details
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="3">
                  <span>Mês</span>
                  <v-select
                    :items="mes"
                    filled
                    v-model="controle.mes"
                    label="Mês"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="3">
                  <span>Ano</span>
                  <v-select
                    :items="ano"
                    filled
                    v-model="controle.ano"
                    label="Ano"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>
              </v-row>

              <v-card-actions class="d-flex justify-end">
                <v-btn color="primary" @click="adiciona_controle()">
                  <v-icon left>mdi-content-save</v-icon> Salvar
                </v-btn>
              </v-card-actions>
            </v-form>

            <v-row>
              <v-col cols="12" sm="6" md="2">
                <span><v-icon>mdi-filter</v-icon> Filtrar por Mês</span>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filtroMesAno"
                      label="Mês"
                      dense
                      solo-inverted
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="filtroMesAnoRaw"
                    type="month"
                    no-title
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-data-table
              style="margin-top: 1rem"
              :headers="ranking_header"
              :items="listaFiltrada"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <br />
              <br />
              <br />

              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha" style="width: 40%; font-size: 14px">
                    {{ row.item.pessoa }} - CPF:
                    {{
                      row.item.documento
                        ? row.item.documento.slice(0, 6) + "***"
                        : "SEM CPF"
                    }}
                  </td>

                  <td class="linha" style="width: 25%; font-size: 14px">
                    {{ row.item.tipo }}
                  </td>

                  <td class="linha" style="width: 15%; font-size: 14px">
                    {{ row.item.mes }} / {{ row.item.ano }}
                  </td>

                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{ row.item.data_insert }}
                  </td>

                  <td class="linha" style="width: 10%; font-size: 14px">
                    <v-btn @click="deleta(row.item.id)" fab small color="error">
                      <v-icon dark> mdi-delete </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import FiltroComponent from "./components/FiltroGeral.vue"; // Certifique-se de que o caminho esteja correto
import Comissao from "../../services/comissao";
import { ContentLoader } from "vue-content-loader";

export default {
  name: "Obitos",
  components: {
    apexcharts: VueApexCharts,
    FiltroComponent,
    ContentLoader,
  },

  created() {},

  mounted() {
    this.getVendedores();
    this.getLocais();
    this.getListaControle();
  },

  computed: {
    vendedoresFormatados() {
      return this.lista_vendedores.map((vendedor) => ({
        ...vendedor,
        displayName: `${vendedor.nome} - ${vendedor.cargo}`,
      }));
    },
    filtroMesAno: {
      get() {
        if (!this.filtroMesAnoRaw) return "";
        const [ano, mes] = this.filtroMesAnoRaw.split("-");
        return `${mes}/${ano}`; // exibe MM/YYYY
      },
      set(value) {
        if (!value) {
          this.filtroMesAnoRaw = "";
          return;
        }
        const [mes, ano] = value.split("/");
        this.filtroMesAnoRaw = `${ano}-${mes}`; // guarda YYYY-MM
      },
    },
    listaFiltrada() {
      if (!this.filtroMesAnoRaw) return this.lista_controle;

      const [ano, mes] = this.filtroMesAnoRaw.split("-");

      return this.lista_controle.filter(
        (item) =>
          String(item.mes).padStart(2, "0") === mes && String(item.ano) === ano,
      );
    },
  },

  data() {
    return {
      lista_vendedores: [],
      ranking_header: [
        { text: "Colaborador", value: "name" },
        { text: "Local", value: "local" },
        { text: "Mês/Ano", value: "mes" },
        { text: "Cadastro", value: "cadastro" },
        { text: "Opção", value: "opcao" },
      ],
      lista_controle: [],
      produto: "Todos",
      controle: {
        codigoPessoa: "",
        mes: "",
        ano: "",
      },

      isLoading: false,
      showFilterRegras: false,
      animationInterval: null, // Intervalo para controlar a animação
      empresa: "",
      selectedCompany: "Todas",
      selectedType: "Todos",
      selectedOpcao: "Todas",
      categoria: [],
      showFilter: false,
      showProgress: false,
      showError: false,
      showFilterDownload: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "Todas",
      ],
      tipos: ["Todos"],
      tipos_funerarios: ["Todos"],
      mes: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      ano: ["2024", "2025", "2026", "2027"],
      filtroMesAnoRaw: new Date().toISOString().slice(0, 7),
      menu: false,
      locais: [],
    };
  },

  methods: {
    adiciona_controle() {
      Comissao.adiciona(this.controle)
        .then((response) => {})
        .catch((e) => {})
        .finally(() => {
          this.getListaControle();
          this.clear();
        });
    },

    deleta(id) {
      Comissao.deletar(id)
        .then((response) => {})
        .catch((e) => {})
        .finally(() => {
          this.getListaControle();
        });
    },

    getLocais() {
      Comissao.lista_locais()
        .then((response) => {
          if (response.status === 200) {
            this.locais = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {});
    },

    getVendedores() {
      Comissao.lista_vendedores()
        .then((response) => {
          if (response.status === 200) {
            this.lista_vendedores = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {});
    },

    getListaControle() {
      this.isLoading = true;

      Comissao.lista_controle()
        .then((response) => {
          if (response.status === 200) {
            this.lista_controle = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });
    },

    clear() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}
/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: rgb(
    71 130 180
  ); /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}
</style>
